export default __webpack_public_path__ + "static/column-offset-light-de745afe1de44445388a4d0256760d0c.png";